import React, { useState, memo } from 'react';
import { Check, ChevronDown, ChevronUp } from 'lucide-react';
const tomos = [{
  icon: '📘',
  title: '1. Tarot Listo™',
  subtitle: 'Tu Guía Completa para Aprender Tarot desde Cero.',
  items: ['Qué es el Tarot y cómo funciona realmente', 'Cómo elegir y conectar con tu mazo personal', 'Interpretación de Arcanos Mayores y Menores', 'Dominio de las Cartas de la Corte', 'Cómo interpretar varias cartas juntas con fluidez', 'Desarrollo de tu intuición natural', 'Ética y buenas prácticas del lector']
}, {
  icon: '🎴',
  title: '2. Tiradas Poderosas™',
  subtitle: 'Aprende cuándo utilizar cada tirada según la consulta.',
  items: ['Tiradas específicas para el Amor y vínculos', 'Lecturas de Dinero y abundancia', 'Consultas de Trabajo y carrera profesional', 'Tiradas de Propósito de vida y misión', 'Lecturas de Crecimiento personal y espiritual']
}, {
  icon: '📖',
  title: '3. Diccionario Intuitivo™',
  subtitle: 'Consulta rápida de los 78 Arcanos sin desesperar.',
  items: ['Explicaciones claras y directas de cada carta', 'Palabras clave para memorización rápida', 'Orientación práctica para interpretaciones', 'Ideal para tener abierto mientras practicas', 'Significados en luz y sombra (derecha/revés)']
}, {
  icon: '🌿',
  title: '4. Rituales con Tarot™',
  subtitle: 'Crea un ambiente de calma, concentración y conexión.',
  items: ['Limpieza energética profunda del mazo', 'Preparación sagrada del espacio de lectura', 'Rituales según las fases lunares', 'Uso consciente de cristales y sahumos', 'Cierre energético y protección']
}, {
  icon: '❓',
  title: '5. Preguntas Mágicas™',
  subtitle: 'La calidad de una lectura depende de la calidad de la pregunta.',
  items: ['Cómo formular preguntas claras y profundas', 'Preguntas que debes evitar a toda costa', 'Cómo obtener respuestas útiles y reveladoras', 'Transformar dudas vagas en consultas poderosas', 'El arte de preguntar para el autoconocimiento']
}, {
  icon: '🔮',
  title: '6. Lecturas Reales™',
  subtitle: 'Nada enseña más que ver el Tarot en acción.',
  items: ['Análisis de casos prácticos paso a paso', 'Cómo conectar cartas dentro de una misma lectura', 'Ganar seguridad interpretando situaciones complejas', 'Ejemplos de lecturas de amor, trabajo y salud', 'Guía visual de conexiones entre arcanos']
}];
const features = ['Sistema paso a paso para principiantes', 'Enfoque en la intuición, no solo memoria', 'Material gráfico de alta calidad', 'Ejercicios prácticos desde el primer día', 'Acceso inmediato y de por vida', 'Compatible con todos los dispositivos'];
export function TomosSection() {
  const [expandedIdx, setExpandedIdx] = useState<number | null>(0);
  return <div className="max-w-xl mx-auto relative z-10" data-id="element-307">
      <div className="space-y-6 mb-16" data-id="element-308">
        {tomos.map((tomo, idx) => {
        const isOpen = expandedIdx === idx;
        return <div key={idx} className="bg-white rounded-3xl overflow-hidden transition-all shadow-premium border border-brand-petroleum/5" data-id="element-309">
              <button onClick={() => setExpandedIdx(isOpen ? null : idx)} className="w-full p-8 flex items-start gap-6 text-left" data-id="element-310">
                <span className="text-3xl flex-shrink-0" data-id="element-311">{tomo.icon}</span>
                <div className="flex-grow min-w-0" data-id="element-312">
                  <h3 className="text-lg font-bold text-brand-petroleum mb-1 tracking-tight" data-id="element-313">
                    {tomo.title}
                  </h3>
                  <p className="text-sm text-brand-medium-grey font-medium leading-relaxed" data-id="element-314">
                    {tomo.subtitle}
                  </p>
                </div>
                {isOpen ? <ChevronUp size={22} className="text-brand-gold-warm flex-shrink-0 mt-1" data-id="element-315" /> : <ChevronDown size={22} className="text-brand-medium-grey/30 flex-shrink-0 mt-1" data-id="element-316" />}
              </button>
              {isOpen && <div className="px-8 pb-8 pl-20" data-id="element-317">
                  <div className="space-y-4" data-id="element-318">
                    {tomo.items.map((item, i) => <div key={i} className="flex items-center gap-4" data-id="element-319">
                        <Check className="text-brand-sage-green" size={18} data-id="element-320" />
                        <span className="text-sm text-brand-dark-grey font-medium leading-relaxed" data-id="element-321">
                          {item}
                        </span>
                      </div>)}
                  </div>
                </div>}
            </div>;
      })}
      </div>

      <div className="bg-brand-soft-cream rounded-[32px] p-10 border border-brand-petroleum/10" data-id="element-322">
        <h3 className="text-xl font-bold text-center text-brand-petroleum mb-10 tracking-tight" data-id="element-323">
          ✨ Tu aprendizaje garantizado:
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-324">
          {features.map((feature, idx) => <div key={idx} className="flex items-center gap-4" data-id="element-325">
              <div className="bg-white p-1 rounded-full shadow-sm" data-id="element-326">
                <Check className="text-brand-gold-warm" size={16} data-id="element-327" />
              </div>
              <span className="text-xs text-brand-dark-grey font-bold uppercase tracking-widest" data-id="element-328">
                {feature}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}